export enum PhoneFormat {
  E164 = 'E.164',
  NATIONAL = 'NATIONAL',
  INTERNATIONAL = 'INTERNATIONAL',
}
